import { s as l, _ as o } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as r, c as m } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var i = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, t),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      d: "m3.651 2.957 19.57 28.465c-2.055.377-4.654.555-7.221.578-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .586-2.8 2.785-4.918Zm24.696 26.086L8.787.592C10.84.216 13.435.022 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.584 2.427.808 4.906.831 7.187v.788l-.002.132.002.134v.657c-.022 2.29-.27 4.817-.865 7.317 0 0-.586 2.802-2.786 4.92Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "m2.738 3.982 19.019 27.664c-1.76.225-3.768.336-5.757.354-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .418-1.997 1.872-3.893Zm26.524 24.035L10.25.365C12.008.138 14.013.018 16 0c3.75.033 7.567.432 9.69 1.263 4.447 1.728 5.477 6.646 5.477 6.646.663 2.758.862 5.582.83 8.107.032 2.493-.2 5.317-.864 8.108 0 0-.418 1.997-1.871 3.893Z",
      clipRule: "evenodd"
    }
  )
), a = r(i)`
  ${l}
  ${m}
`, w = a;
export {
  w as default
};
